import { Box, Stack, Typography } from '@mui/material';

import { ScoreType, Sector } from '@/domain/impact/impact.entity';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSCard } from '@/ui/components/FSCard';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

import { GraphicWithValueAndRefValue } from './components/GraphicWithValueAndRefValue';
import { IconScoreBadge } from './components/IconScoreBadge';
import { ItemsList } from './components/ItemsList';
import { TopicScoreDetailsData } from './type';

interface IProps {
  type: ScoreType;
  data: TopicScoreDetailsData;
  showAnswerAll?: boolean;
  onClickAnswerAll: (type: ScoreType) => void;
  onClickDetailsItem: (type: ScoreType, id: string, sector?: Sector) => void;
}

export function TopicScoreAndDetailsCard({
  type,
  data,
  showAnswerAll = true,
  onClickAnswerAll,
  onClickDetailsItem,
}: IProps) {
  return (
    <FSCard
      sx={{
        p: 3,
        backgroundColor: ColorsRaw.anthracite.Anthracite_2,
        borderColor: ColorsRaw.anthracite.Anthracite_3,
        alignItems: 'center',
      }}
    >
      <Stack direction={'column'} alignItems={'center'} spacing={2}>
        <Title type={type} />
        <IconScoreBadge type={type} data={data} />
        <GraphicWithValueAndRefValue type={type} data={data} />
        <Box sx={{ width: '100%', py: 4 }}>
          <ItemsList
            data={data}
            onClick={(id, sector) => onClickDetailsItem(type, id, sector)}
          />
        </Box>
        {showAnswerAll && (
          <AnswerAllButton type={type} onClickAnswerAll={onClickAnswerAll} />
        )}
      </Stack>
    </FSCard>
  );
}

function Title({ type }: { type: ScoreType }) {
  return <Typography variant="h6">{translate(`Projects.${type}`)}</Typography>;
}

function AnswerAllButton({
  type,
  onClickAnswerAll,
}: {
  type: ScoreType;
  onClickAnswerAll: (type: ScoreType) => void;
}) {
  return (
    <Box display={'flex'} justifyContent={'center'}>
      <FSPrimaryButton color="info" onClick={() => onClickAnswerAll(type)}>
        {translate('Sector.answer-all')}
      </FSPrimaryButton>
    </Box>
  );
}
